import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PokeHome from "../views/PokeHome"
import PokeDetail from "../views/PokeDetail"
import PokeNotFound from "../views/PokeNotFound"

export default function Routes(){
    return (
        <Router>
            <Switch>
                <Route path="/" exact>
                    <PokeHome />
                </Route>

                <Route path="/pokemon/:id">
                    <PokeDetail />
                </Route>

                <Route path="/pokemons/favorites" exact>
                    <div>Pokemon Favorites</div>
                </Route>

                <Route path="*" insecure component={PokeNotFound} />
            </Switch>
        </Router>
    );
}